import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsRoutesResponse } from "../../Orchestrator/Types/Interface/ICmsRoutes";

export async function getCmsRoutes(): Promise<
  IApiResponse<ICmsRoutesResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getRoutesAPI;

  const params = new URLSearchParams({
    "populate[origin][populate]": "image",
    "populate[destination][populate]": "image",
    locale: await getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsRoutesResponse>(endpointWithParams, "GET");
}
